<template>
  <modal
    name="artist-modal"
    class="artist-modal"
    height="auto"
    :max-width="594"
    :adaptive="true"
    width="95%"
  >
    <div class="artist-modal__wrap">
      <button
        class="artist-modal__close"
        v-on:click="$modal.hide('artist-modal')"
      >
        <base-svg class="svg" icon="close" />
      </button>
      <p
        class="artist-modal__title"
        v-html="'Выберите художника из&nbsp;списка'"
      />
      <div class="artist-modal__inner">
        <div class="artist-modal__top">
          <ul class="artist-modal__letters-list">
            <li v-for="item in groupedArtists" :key="item.id">
              <button
                class="artist-modal__letter"
                :class="{ _active: activeLetter === item.letter }"
                @click="toggleLetter(item.letter)"
                type="button"
              >
                {{ item.letter }}
              </button>
            </li>
          </ul>
          <div class="artist-modal__search">
            <label class="artist-modal__search-label" for="query"
              >Поиск по фамилии</label
            >
            <div class="artist-modal__search-wrap">
              <input
                class="artist-modal__search-control"
                type="text"
                id="query"
                name="query"
                v-model="searchQuery"
                @input="searchArtists"
              />
            </div>
          </div>
        </div>
        <div class="artist-modal__main">
          <vue-custom-scrollbar
            class="scroll-area"
            :settings="settings"
            @ps-scroll-y="scrollHanle"
          >
            <div class="artist-modal__empty" v-if="filteredArtists.length <= 1">
              <p>
                По&nbsp;вашему запросу ничего не&nbsp;найдено. <br />
                Измените запрос или выберите &laquo;Другое&raquo;, затем нажмите
                &laquo;Готово&raquo; и&nbsp;укажите ФИО в&nbsp;поле для
                дополнительной информации.
              </p>
            </div>
            <ul class="artist-modal__list">
              <li
                class="artist-modal__list-item"
                :class="{ _other: artist.id === 0 }"
                v-for="artist in filteredArtists"
                :key="artist.id"
              >
                <label
                  class="artist-modal__radio"
                  :class="{ _active: selectedArtist === artist.name }"
                >
                  <input
                    class="visually-hidden"
                    type="radio"
                    name="artist"
                    :value="artist.name"
                    v-model="selectedArtist"
                    @change="onArtistSelected(artist.name)"
                  />
                  <span v-html="highlightText(artist.name)"></span>
                </label>
              </li>
            </ul>
          </vue-custom-scrollbar>
        </div>
      </div>
      <div class="artist-modal__bottom">
        <base-button
          default
          size="large"
          title="Готово"
          :disabled="!selectedArtist"
          @click.native="handleSubmit"
        />
      </div>
    </div>
  </modal>
</template>
<script>
import Vue from "vue";
import VModal from "vue-js-modal";
Vue.use(VModal);
import BaseSvg from "@/components/base/BaseSvg";
import BaseButton from "@/components/buttons/BaseButton.vue";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
  name: "ArtistModal",
  components: { BaseButton, BaseSvg, vueCustomScrollbar },
  props: {
    title: String,
    text: String,
  },
  data() {
    return {
      artists: [],
      groupedArtists: [],
      activeLetter: null,
      searchQuery: "",
      filteredArtists: [],
      selectedArtist: null,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: true,
        maxScrollbarLength: 58,
      },
    };
  },
  computed: {
    filteredByLetter() {
      if (!this.activeLetter) {
        return this.artists;
      }
      const group = this.groupedArtists.find(
        (g) => g.letter === this.activeLetter
      );
      return group ? group.items : [];
    },
  },
  created() {
    fetch("/artists.json")
      .then((response) => response.json())
      .then((data) => {
        this.artists = data;
        this.groupedArtists = this.groupByLetter(data);
        this.filteredArtists = [...this.artists];
        this.addOtherOption();
      })
      .catch((error) => console.error("Error loading artists:", error));
  },
  methods: {
    scrollHanle(evt) {
      console.log(evt);
    },
    groupByLetter(artists) {
      const grouped = [];

      artists.forEach((artist) => {
        const firstLetter = artist.name[0].toUpperCase();

        let group = grouped.find((g) => g.letter === firstLetter);

        if (!group) {
          group = { letter: firstLetter, items: [] };
          grouped.push(group);
        }

        group.items.push(artist);
      });

      return grouped;
    },

    toggleLetter(letter) {
      if (this.activeLetter === letter) {
        this.activeLetter = null;
      } else {
        this.activeLetter = letter;
      }

      this.updateFilteredArtists();
    },

    searchArtists() {
      this.updateFilteredArtists();
    },

    updateFilteredArtists() {
      let filtered = this.filteredByLetter;

      const query = this.searchQuery.trim().toLowerCase();
      if (query) {
        filtered = filtered.filter((artist) =>
          artist.name.toLowerCase().includes(query)
        );
      }

      this.filteredArtists = filtered;

      this.addOtherOption();
      this.selectedArtist = null;
    },

    addOtherOption() {
      if (!this.filteredArtists.some((artist) => artist.id === 0)) {
        this.filteredArtists.push({ id: 0, name: "Другое" });
      }
    },

    highlightText(text) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) return text;

      const regExp = new RegExp(`(${query})`, "gi");
      return text.replace(regExp, '<span class="highlight">$1</span>');
    },

    onArtistSelected(artistName) {
      this.selectedArtist = artistName;
    },

    handleSubmit() {
      this.$emit("artist-selected", this.selectedArtist);
      this.$modal.hide("artist-modal");
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/helpers/variables";

.artist-modal {
  .vm--modal {
    background: #ffffff;
    /* text/p 707070 */

    border: 1px solid #707070;
    box-sizing: border-box;
    border-radius: 8px;
  }

  .vm--overlay {
    background: rgba(0, 0, 0, 0.43);
  }

  &__wrap {
    position: relative;
    padding: 30px 30px 14px;

    @media #{$xs} {
      padding: 30px 20px;
    }
  }

  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    display: block;
    padding: 0;
    background: transparent;
    border: 0;
    box-shadow: none;
    transition: $base-transition;
    @media #{$xs} {
      top: 15px;
      right: 15px;
    }

    .svg {
      display: block;
      width: 12px;
      height: 12px;
    }

    &:hover {
      color: $link-hover-color;
    }
  }

  &__title {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;
    color: #333333;

    @media #{$xs} {
      font-size: 20px;
      line-height: 120%;
    }
  }
}

.artist-modal__inner {
  padding: 12px;
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}

.artist-modal__letters-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  padding: 0;
  margin: 0 0 20px;
  list-style: none;
}

.artist-modal__letter {
  display: block;
  padding: 0;
  border: 0;
  background: transparent;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  letter-spacing: 2px;
  color: rgba(123, 7, 26, 0.5);

  &._active {
    font-weight: 600;
    color: #7b071a;
  }
}

.artist-modal__search-label {
  display: block;
  margin-bottom: 11px;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  color: #333333;
}

.artist-modal__search-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 16px;
  border-bottom: 1px solid #e0e0e0;

  &::after {
    content: "";
    display: block;
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    background-image: url("data:image/svg+xml,%3Csvg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.70803 8.51623C10.359 7.62165 10.7084 6.5431 10.7055 5.43673C10.7055 2.58373 8.43978 0.271484 5.64378 0.271484C2.84853 0.272234 0.582031 2.58373 0.582031 5.43673C0.582031 8.28898 2.84853 10.6012 5.64453 10.6012C6.90561 10.6011 8.11983 10.1233 9.04278 9.26398C8.92803 9.54448 8.97978 9.88273 9.19728 10.1115L12.3908 13.4752C12.6758 13.7752 13.1385 13.7752 13.4235 13.4752L13.8 13.0792C14.085 12.7792 14.085 12.2917 13.8 11.9917L10.6065 8.62798C10.4941 8.50632 10.3422 8.42831 10.1778 8.40773C10.0134 8.38715 9.84703 8.42531 9.70803 8.51548V8.51623ZM5.63028 9.02173C6.11643 9.02173 6.59783 8.92598 7.04698 8.73994C7.49612 8.55389 7.90423 8.28121 8.24799 7.93744C8.59175 7.59368 8.86444 7.18558 9.05048 6.73643C9.23653 6.28728 9.33228 5.80589 9.33228 5.31973C9.33228 4.83358 9.23653 4.35219 9.05048 3.90304C8.86444 3.45389 8.59175 3.04579 8.24799 2.70202C7.90423 2.35826 7.49612 2.08558 7.04698 1.89953C6.59783 1.71349 6.11643 1.61773 5.63028 1.61773C4.64845 1.61773 3.70683 2.00777 3.01257 2.70203C2.31831 3.39628 1.92828 4.3379 1.92828 5.31973C1.92828 6.30157 2.31831 7.24318 3.01257 7.93744C3.70683 8.6317 4.64845 9.02173 5.63028 9.02173Z' fill='%237B071A'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
}

.artist-modal__search-control {
  display: block;
  width: 100%;
  border: 0;
  outline: unset;
  background: #ffffff;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #707070;
}

.highlight {
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  text-decoration-line: underline;
  color: #7b071a;
}

.artist-modal__bottom {
  display: grid;
  margin-top: 20px;
}

.artist-modal__main {
  padding-top: 16px;

  .ps-container {
    height: 40vh;

    @media #{$sm} {
      padding-bottom: 20px;

      &.ps--scrolling-y {
        .ps__rail-y {
          opacity: 1;
        }
      }
    }
  }
  .ps__rail-y {
    opacity: 1;
    background: #fafafa;
    border-radius: 8px;
  }

  .ps__thumb-y {
    height: 10px;
    border-radius: 8px;
    background-color: $main-brand-color;
  }
}

.artist-modal__list {
  display: grid;
  gap: 12px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.artist-modal__list-item {
  &._other {
    padding: 7px 0;
    border-top: 1px solid #e0e0e0;
  }
}

.artist-modal__radio {
  display: block;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #828282;
  cursor: pointer;

  &._active {
    color: #7b071a;
  }
}

.scroll-area {
  display: flex;
  flex-direction: column;
}

.artist-modal__empty {
  flex-grow: 1;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #333333;
}
</style>
